import type React from "react";

import type { MultiInputQuestionProps } from "./MultiInputQuestion.model";
import { StyledMultiInputQuestion } from "./MultiInputQuestion.styled";

export const MultiInputQuestion: React.FC<MultiInputQuestionProps> = (props) => (
  <StyledMultiInputQuestion {...props} />
);
